var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgText(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h40v40H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#151A30",
    d: "M33.988 8.33a.42.42 0 00.3-.114.402.402 0 00.123-.31c0-.13-.04-.23-.122-.3a.448.448 0 00-.301-.106H5.439a.464.464 0 00-.317.106.375.375 0 00-.122.3.4.4 0 00.122.31.445.445 0 00.317.114h28.549zm0 8.057a.403.403 0 00.423-.424.38.38 0 00-.122-.292.426.426 0 00-.301-.114H5.439a.445.445 0 00-.317.114.383.383 0 00-.122.293.4.4 0 00.122.309.445.445 0 00.317.114h28.549zm0 8.073c.119 0 .22-.041.3-.122a.43.43 0 00.123-.318.38.38 0 00-.122-.293.426.426 0 00-.301-.114H5.439a.445.445 0 00-.317.114.385.385 0 00-.122.293c0 .13.04.236.122.318.081.08.187.122.317.122h28.549zm-13.623 8.056a.397.397 0 00.293-.114.417.417 0 00.113-.309c0-.12-.037-.22-.113-.301a.385.385 0 00-.293-.122H5.439c-.13 0-.236.04-.317.122a.41.41 0 00-.122.301c0 .13.04.233.122.31a.449.449 0 00.317.113h14.926z"
  }))));
}

export default SvgText;